import React, { useContext, useEffect, useState } from "react";

import orderBy from "lodash.orderby";
import { observer } from "mobx-react";

import ComponentContext from "../../../contexts/ComponentContext";
import apiInstance from "../../../services/api";
import Loader from "../Loader/Loader";
import Venue from "../Venue/Venue";

function VenueList() {
  const [venues, setVenues] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const { title, placeholder } = useContext(ComponentContext);

  useEffect(() => {
    apiInstance.getAllVenues().then((response) => {
      setVenues(orderBy(response.data, ["totalVacancies"], "desc"));
      setIsLoading(false);
    });
  }, []);

  return (
    <div className="d-flex flex-column align-items-center">
      {title && <h2 className="text-center mb-5 mt-5">{title}</h2>}
      {isLoading && <Loader />}

      {!isLoading && (
        <div className="row">
          {venues.map((venue) => (
            <div key={venue.id} className="col-6 col-lg-3 mb-5 text-center">
              <Venue placeholder={placeholder} venue={venue} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default observer(VenueList);
